// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"568":"c494036b","717":"82a3414b","766":"37ab64a8"}[chunkId] + ".js";
};